import { posToDOMRect } from '@tiptap/core';
import { SmileSmall } from '@wix/wix-ui-icons-common';

import { type EditorPluginCreator, quickActionsModalSections } from './../ricos-types';

import { getTipTapExtensions } from './extension';
import { getAddButtons } from './getAddButtons';
import EmojiInsertModal from './modals/InsertModal';
import type { EmojiPluginEditorConfig } from './types';
import { EMOJI_TYPE, emojiModals } from './types';
//import 'https://unpkg.com/browse/wix-rich-content-plugin-emoji@6.8.4/dist/styles.min-css';

export const pluginEmoji: EditorPluginCreator<
  EmojiPluginEditorConfig,
  { InsertModal: typeof EmojiInsertModal }
> = config => {
  return {
    config: { ...config },
    type: EMOJI_TYPE,
    tiptapExtensions: getTipTapExtensions(),
    getAddButtons: (config, services) => getAddButtons(config, services),
    getQuickActions: () => [
      {
        id: 'emoji',
        title: 'QuickActionsPlugin_ActionTitle_Emoji',
        icon: SmileSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ['smiley', 'emoticon', 'face', 'reaction', 'emotions', 'symbol'],
        command: ({ modalService, editor }) =>
          modalService.togglePluginPanel({
            id: emojiModals.insert,
            Component: EmojiInsertModal,
            componentProps: {},
            isMobile: false,
            positioning: {
              referenceElement: {
                getBoundingClientRect: () =>
                  posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  ),
              },
              placement: 'bottom-end',
            },
            onClickOutside: () => modalService.closeModal(emojiModals.insert),
          }),
      },
    ],
    __exports: {
      InsertModal: EmojiInsertModal,
    },
  };
};
